package com.essntl.features.task.ui.addedittask.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.alltasks.components.TaskStatusDropDown
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun AddEditTaskHeader(
    task: TaskModel?,
    onEditTaskStatus: (taskId: String, status: TaskModel.Status) -> Unit,
    enabled: Boolean,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
) {
    Column(
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        modifier = modifier
            .fillMaxWidth()
            .clip(
                RoundedCornerShape(
                    bottomStart = 24.dp,
                    bottomEnd = 24.dp,
                ),
            )
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                top = 1.5f.spacing,
                bottom = 2.5f.spacing,
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        if (task != null) {
            TaskStatusDropDown(
                status = task.status,
                onStatusSelected = { newStatus ->
                    if (newStatus != task.status) {
                        onEditTaskStatus(task.id, newStatus)
                    }
                },
                enabled = enabled && !isLoading,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}